<!-- tags-dialog.component.html -->
<div class="tags-dialog-container p-3" tabindex="0" (click)="$event.stopPropagation()"
  (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
  <h6 class="fs-6">Tags</h6>
  <div class="d-flex w-100" [ngClass]="data.isBottom ? 'flex-column-reverse' : 'flex-column'">
    <div class="p-1">
      <form [formGroup]="editTagForm" (ngSubmit)="onAddTag()">
        @if (data.canEdit !== false) {
        <mat-form-field appearance="outline" class="w-100">
          <input #tagInput matInput formControlName="tag_name" placeholder="Add Tag" [attr.maxLength]="limits.name">
          @if (editTagForm.get('tag_name')?.hasError('required')) {
          <mat-error>
            Tag name is required
          </mat-error>
          }
        </mat-form-field>
        }

        <div class="d-flex justify-content-center g...ap-2 mt-3">
          <button class="secondary-btn w-100" mat-flat-button type="button" (click)="onClose()">Close</button>
          @if (data.canEdit !== false) {
          <button class="primary-btn w-100" mat-flat-button type="submit">Add</button>
          }
        </div>
      </form>
    </div>
    @if (screen.tags && screen.tags.length>0) {
    <div class="p-1 d-inline-flex flex-wrap">
      @for (tag of screen.tags; track tag) {
      <span class="rounded-card-grey tag-chip position-relative me-1 mb-1 d-inline-flex align-items-center"
        [class.pe-4]="data.canEdit !== false" [class.px-2]="data.canEdit === false"
        matTooltip="{{tag}}">
        <span class="tag-chip__label d-inline-block text-truncate">{{tag}}</span>
        @if (data.canEdit !== false) {
        <span type="button" tabindex="0" class="btn-close position-absolute end-0 ps-1 pe-3 small pt-1"
          aria-label="Close" (click)="onRemoveTag(tag)" (keydown.enter)="onRemoveTag(tag)"
          (keydown.space)="onRemoveTag(tag)"></span>
        }
      </span>
      }
    </div>
    }
  </div>
</div>